import { useDispatch } from "react-redux";
import { AppActions } from "../CommonApp/appSlice";
import { useAppSelector } from "../app/hooks";

export default function usePageLoader() {
  const dispatch = useDispatch();
  const setFullPageLoader = (open) => {
    return dispatch(AppActions.actions.setFullPageLoader(open));
  };
  return setFullPageLoader;
}

export function useSaving() {
  return useAppSelector((state) => state?.app?.common?.fullPageLoaderOpen);
}
